<pt-breadcrumbs current="Organisations" class="bg-white" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-4 sm:flex-row sm:items-stretch">
      <pt-search-field class="flex-1">
        <input matInput placeholder="Search" [formControl]="search" />
      </pt-search-field>
      <button mat-raised-button color="primary" (click)="addOrganisation()">
        Create Organisation
      </button>
    </div>

    <div class="rounded-sm shadow-md">
      <table
        mat-table
        matSort
        matSortActive="name"
        matSortDirection="asc"
        class="w-full"
        [dataSource]="dataSource"
      >
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
          <td *matCellDef="let row" mat-cell>
            <a
              class="font-medium"
              [routerLink]="['./', row.organisation.ref.id]"
            >
              {{ row.organisation.name }}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="region">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Region</th>
          <td *matCellDef="let row" mat-cell>{{ row.organisation.region }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
          <td *matCellDef="let row" mat-cell>
            <pr-organisation-status
              dense
              class="[&>pr-status-label]:w-20"
              [status]="row.organisation.status"
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagers">
          <th *matHeaderCellDef mat-header-cell>Account Managers</th>
          <td *matCellDef="let row" mat-cell>
            <div class="flex items-center -space-x-1">
              <ng-container
                *ngFor="
                  let staffer of row.accountManagers;
                  trackBy: trackByStaffer
                "
              >
                <pt-user-icon
                  [name]="staffer.user.name"
                  [diameter]="28"
                  [matTooltip]="staffer.user.name"
                />
              </ng-container>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let row" mat-cell>
            <a
              mat-icon-button
              matTooltip="View Details"
              [routerLink]="['./', row.organisation.ref.id]"
            >
              <mat-icon>chevron_right</mat-icon>
            </a>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        <tr *matNoDataRow class="mat-row">
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <pr-empty-state image="list" title="organisations" />
          </td>
        </tr>
      </table>

      <mat-paginator
        showFirstLastButtons
        [length]="dataSource.data.length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
      />
    </div>
  </div>
</div>
